<template>
  <SideDrawer :is-open="appStore.isSubNavOpen" temporary>
    <template #prepend>
      <v-list-item class="text-end">
        <v-btn
          icon="$close"
          size="small"
          variant="text"
          @click="appStore.isSubNavOpen = false"
        />
      </v-list-item>
    </template>
    <v-list v-if="appStore.isSubNavOpen">
      <template v-for="(item, index) in subCategoryModel" :key="index">
        <SideNavigationDrawerItem
          v-if="item.childNav.length === 0"
          :to="item.to"
          :title="item.title"
          :icon="item.icon"
        />
        <SideNavigationDrawerExpand
          v-else
          :to="item.to"
          :title="item.title"
          :icon="item.icon"
          :items="item.childNav"
        />
      </template>
    </v-list>
    <template #append>
      <slot name="append" />
    </template>
  </SideDrawer>
  <SideDrawer
    temporary
    :is-open="appStore.isNavOpen"
    @update:toggle-visible="appStore.toggleNav()"
  >
    <v-list :slim="true">
      <template
        v-for="(item, index) in navigation.navigationItems"
        :key="index"
      >
        <SideNavigationDrawerItem
          :to="item.childNav.length > 0 ? '' : item.to"
          :title="item.title"
          :icon="item.icon"
          :items="item.childNav"
          @click="toggleSubCategory(item.childNav)"
        />
      </template>
    </v-list>
    <template #append>
      <SideNavigationDrawerItem
        to=""
        title="Toggle theme"
        :icon="
          settings.theme.isThemeDark()
            ? 'mdi-theme-light-dark'
            : 'mdi-theme-light-dark'
        "
        @click="settings.theme.toggleTheme"
      />
      <slot name="append" />
    </template>
  </SideDrawer>
</template>
<script setup lang="ts">
  // import composables
  import useSettings from '@/composables/useSettings/useSettings';
  import { ref, onMounted } from 'vue';
  import { useAppStore } from '@/store/app/appStore';
  import useNavigation from '@/composables/useNavigation/useNavigation';
  // import components
  import SideDrawer from '@/layouts/private/components/SideNavigation/SideDrawer.vue';
  import SideNavigationDrawerItem from '@/layouts/private/components/SideNavigation/SideNavigationDrawerItem.vue';
  import SideNavigationDrawerExpand from '@/layouts/private/components/SideNavigation/SideNavigationDrawerExpand.vue';
  import router from '@/router';
  // import enums
  import Routes from '@/enums/Routes';

  router.beforeEach(() => {
    appStore.isNavOpen = false;
    appStore.isSubNavOpen = false;
  });

  onMounted(() => {
    navigation.navigationItems.forEach((item) => {
      // Check if the item is the home page
      if (item.to === Routes.HOME) {
        appStore.isNavOpen = true;
        appStore.isSubNavOpen = false;
      }
      // Check if the item matches the current route and is not home
      else if (item.to === router.currentRoute.value.path) {
        appStore.isNavOpen = true;
        appStore.isSubNavOpen = item.childNav.length > 0;
      }

      // Update subCategoryModel if there are child navigation items
      if (item.childNav.length > 0) {
        subCategoryModel.value = item.childNav;
      }
    });
  });

  const appStore = useAppStore();
  const settings = useSettings();
  const navigation = useNavigation();

  const subCategoryModel = ref<
    Array<{
      title: string;
      icon: string;
      to: string;
      childNav: Array<{ title: string; icon: string; to: string }>;
    }>
  >([]);

  const toggleSubCategory = (
    subCategories: Array<{
      title: string;
      icon: string;
      to: string;
      childNav: Array<{ title: string; icon: string; to: string }>;
    }>
  ) => {
    if (subCategories.length === 0) {
      return;
    }
    // for rail navigation

    if (appStore.isNavOpen) {
      subCategoryModel.value = subCategories;
      appStore.isSubNavOpen = true;
    }
  };

  defineProps({
    navigationItems: {
      type: Array<{
        to: string;
        title: string;
        icon: string;
        childNav: Array<{ to: string; title: string; icon: string }>;
      }>,
      default: () => [],
    },
  });
</script>
